var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFee = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.095 3.055a2.11 2.11 0 0 0-2.1 2.12v13.65a2.11 2.11 0 0 0 2.1 2.12h8.23a2.104 2.104 0 0 0 2.078-1.817.85.85 0 0 1 1.684.234 3.804 3.804 0 0 1-3.762 3.283h-8.23c-2.105 0-3.8-1.716-3.8-3.82V5.175c0-2.104 1.695-3.82 3.8-3.82h8.23c2.105 0 3.8 1.716 3.8 3.82v6.01a.85.85 0 1 1-1.7 0v-6.01a2.11 2.11 0 0 0-2.1-2.12z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.275 12.675a2.73 2.73 0 1 0 0 5.46 2.73 2.73 0 0 0 0-5.46m-4.43 2.73a4.43 4.43 0 1 1 8.86 0 4.43 4.43 0 0 1-8.86 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.668 5.382c0-.47.38-.85.85-.85h4.17a.85.85 0 1 1 0 1.7h-4.17a.85.85 0 0 1-.85-.85"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.668 8.882c0-.47.38-.85.85-.85h5.92a.85.85 0 1 1 0 1.7h-5.92a.85.85 0 0 1-.85-.85"
}))));
export default SvgFee;